import dayjs from 'dayjs';
import { MetricEntityType, MetricInterval } from './metricFilter';

export enum MetricResultType {
  company = 'company',
  type = 'type',
}

export default class MetricResult {
  companyId!: string;
  label!: string;
  value!: number;
  type!: MetricEntityType;

  constructor(obj: any) {
    Object.assign(this, obj);
  }

  static toChartBarStackedData(
    metrics: MetricResult[],
    interval: MetricInterval,
    locale: string,
  ): { data: MetricResult[]; type: MetricResultType } {
    const labels = new Set<string>(metrics.map(m => m.label));

    const companyIds = new Set<string>(metrics.map(m => m.companyId));
    const types = new Set<MetricEntityType>(metrics.map(m => m.type));

    const identifiers = companyIds.size === 1 ? types : companyIds;

    const data: any[] = [];

    Array.from(labels)
      .sort((a, b) => dayjs(a).unix() - dayjs(b).unix())
      .forEach(label => {
        let item: string = label;
        if (interval === MetricInterval.day) {
          item = new Date(label).toLocaleDateString(locale, { month: '2-digit', day: '2-digit' });
        } else if (interval === MetricInterval.month) {
          item = new Date(label).toLocaleDateString(locale, { year: 'numeric', month: '2-digit' });
        } else if (interval === MetricInterval.year) {
          item = new Date(label).toLocaleDateString(locale, { year: 'numeric' });
        }

        const entry: any = { label: item };
        identifiers.forEach(id => {
          const items = metrics.filter(m => (m.companyId === id || m.type === id) && m.label === label);
          items.forEach(metric => (entry[id] = (entry[id] || 0) + metric.value));
        });

        data.push(entry);
      });

    return { data, type: companyIds.size === 1 ? MetricResultType.type : MetricResultType.company };
  }

  static toChartNumberData(metrics: MetricResult[], interval: MetricInterval, locale: string) {
    return metrics.reduce((acc, metric) => acc + metric.value, 0);
  }
}
